<template>
	<div id="pagedetail">
		<div class="cent">
			<topinfo></topinfo>
			<navbar></navbar>
			<page :iteminfo="iteminfo"></page>
		</div>
		<banquan></banquan>
	</div>
</template>

<script>
	import topinfo from 'components/topinfo/topinfo'
	import navbar from 'components/navbar/navbar'
	import page from './child/page.vue'
	import banquan from 'components/banquan/banquan'
	
	import {getnavinfo2} from 'network/home'
	
	export default{
		name:'pagedetail',
		data(){
			return{
				iteminfo:[]
			}
		},
		created() {
			document.title = this.$route.params.index+'-综合优质网络资源收集分享_游戏辅助资源下载网_爱资源_爱分享'
			getnavinfo2(this.$route.params.index).then(res =>{
				this.iteminfo.push(...res.data.msg)
			})
		},
		methods:{
		},
		components:{
			topinfo,
			navbar,
			page,
			banquan
		}
	}
</script>

<style scoped>
	#pagedetail{
		background: url('https://api.ixiaowai.cn/api/api.php') no-repeat top;
		height: 100%;
		background-size:100% 100%;
	}
	.cent{
		padding-top: 5px;
		width: 1200px;
		background: #ffffff;
		box-shadow: 0px 0px 5px 5px #c0c0c0;
		margin: auto;
	}
</style>